import { gsap, TimelineMax, Power2 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollMagic from 'scrollmagic';
import jQuery from 'jquery';
import Barba from '@barba/core';
import App from './App';
import Menu from './Menu';

gsap.registerPlugin(ScrollTrigger);

const Legacy = {
  legacyController: null,

  LegacySlider: function () {
    // Clear any possible previous initialization
    if (jQuery('.legacy-slider').hasClass('slick-initialized')) {
      jQuery('.legacy-slider').slick('unslick');
    }

    if (jQuery('.legacy-slider-content').hasClass('slick-initialized')) {
      jQuery('.legacy-slider-content').slick('unslick');
    }

    // Initialize variables
    let $LegacyCurrentStatus = jQuery('.current-slider'),
      $LegacyTotalStatus = jQuery('.total-slider'),
      $LegacySliderControler,
      $LegacySlider = jQuery('.legacy-slider'),
      slider,
      $LegacyTotalCount,
      $LegacyCurrentCount;

    // Set initial numbers based on DOM count before any initialization
    const initialSlideCount = $LegacySlider.children().length;
    $LegacyCurrentStatus.text('1');
    $LegacyTotalStatus.text(initialSlideCount);
    $LegacyTotalCount = initialSlideCount;
    $LegacyCurrentCount = 1;

    // First, initialize the sliders
    // Slick initialization
    jQuery('.legacy-slider')
      .not('.slick-initialized')
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        draggable: false,
        asNavFor: '.legacy-slider-content',
        prevArrow: jQuery('.left-arrow svg'),
        nextArrow: jQuery('.right-arrow svg'),
        cssEase: 'ease-out',
      });

    jQuery('.legacy-slider-content').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.legacy-slider',
      draggable: false,
      dots: false,
      fade: true,
      focusOnSelect: true,
      cssEase: 'ease-out',
    });

    // Now set up the event handlers after slick is initialized
    jQuery('.legacy-slider').on(
      'init reInit afterChange',
      function (event, slick, currentSlide, nextSlide) {
        // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        const i = (currentSlide ? currentSlide : 0) + 1;
        if ($LegacyCurrentStatus.length) {
          $LegacyCurrentStatus.text(i);
        }

        if ($LegacyTotalStatus.length && slick && slick.slideCount) {
          $LegacyTotalStatus.text(slick.slideCount);
          $LegacyTotalCount = slick.slideCount;
          $LegacyCurrentCount = i;

          // Only try to use the slider if it exists and is initialized
          if (jQuery('.progress-bar').length && jQuery('.progress-bar').slider) {
            const newValue = ($LegacyCurrentCount / $LegacyTotalCount) * 100;
            jQuery('.progress-bar').slider('value', newValue);

            // Calculate controller size
            const $controllerSize = 100 / $LegacyTotalCount;

            // Slider Controller Width and Position
            jQuery('.legacy-slider__wrapper .ui-slider-handle').css({
              width: $controllerSize + '%',
              'margin-left': '-' + $controllerSize + '%',
            });
          }
        }
      }
    );

    // Initialize jQuery UI Slider for the progress bar if it exists
    if (jQuery('.legacy-slider-controller .progress-bar').length) {
      // Jquery UI Slider Controller element
      slider = jQuery('.legacy-slider-controller .progress-bar').slider({
        min: 0,
        max: 100, // Use a default value initially
        animate: 'slow',
        step: 0.0001,
        disabled: true,
        slide: function (event, ui) {
          if ($LegacySlider.hasClass('slick-initialized')) {
            const slick = $LegacySlider.slick('getSlick');
            const goTo = Math.round((ui.value * (slick.slideCount - 1)) / 100);
            $LegacySlider.slick('goTo', goTo);
          }
        },
      });
    }

    // Ensure arrow controls work properly
    jQuery('.left-arrow svg')
      .off('click')
      .on('click', function () {
        if (jQuery('.legacy-slider').hasClass('slick-initialized')) {
          jQuery('.legacy-slider').slick('slickSetOption', 'autoplay', false).slick('slickPause');
          jQuery('.legacy-slider').slick('slickPrev');
        }
      });

    jQuery('.right-arrow svg')
      .off('click')
      .on('click', function () {
        if (jQuery('.legacy-slider').hasClass('slick-initialized')) {
          jQuery('.legacy-slider').slick('slickSetOption', 'autoplay', false).slick('slickPause');
          jQuery('.legacy-slider').slick('slickNext');
        }
      });

    // Trigger the init event to update counters and progress
    $LegacySlider.trigger('afterChange');
  },

  LegacyMobile: function () {
    if (App.isMobile()) {
      // Mobile specific functionality
    }
  },

  TreeTooltips: function () {
    // Debug output to check if function is being called
    console.log('TreeTooltips function called');

    // Check if tooltip buttons exist and log count
    const tooltipBtns = jQuery('.tooltip-btn');
    console.log('Found tooltip buttons:', tooltipBtns.length);

    // First remove any existing event handlers to prevent duplicates
    jQuery('.tooltip-btn').off('click');

    // Add new click event handler with proper functionality
    jQuery('.tooltip-btn').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      console.log('Tooltip button clicked');

      // Close any other open tooltips first
      jQuery('.tooltip-btn.active')
        .not(this)
        .each(function () {
          jQuery(this).find('svg').css({
            transform: 'rotate(90deg)',
          });
          jQuery(this).find('.tooltip-content').removeClass('active');
          jQuery(this).removeClass('active');
        });

      // Toggle the clicked tooltip
      if (!jQuery(this).hasClass('active')) {
        // Open the tooltip
        jQuery(this).find('svg').css({
          transform: 'rotate(45deg)',
        });
        jQuery(this).find('.tooltip-content').addClass('active');
        jQuery(this).addClass('active');

        console.log('Tooltip activated');
      } else {
        // Close the tooltip
        jQuery(this).find('svg').css({
          transform: 'rotate(90deg)',
        });
        jQuery(this).find('.tooltip-content').removeClass('active');
        jQuery(this).removeClass('active');
      }
    });

    // Close tooltips when clicking elsewhere on the page
    jQuery(document).on('click', function (e) {
      if (!jQuery(e.target).closest('.tooltip-btn, .tooltip-content').length) {
        jQuery('.tooltip-btn.active').each(function () {
          jQuery(this).find('svg').css({
            transform: 'rotate(90deg)',
          });
          jQuery(this).find('.tooltip-content').removeClass('active');
          jQuery(this).removeClass('active');
        });
      }
    });
  },

  legacyScrollAnim: function () {
    // Make sure we don't have an existing controller
    if (this.legacyController === null) {
      this.legacyController = new ScrollMagic.Controller();
    }

    const roundOff = (progress) => Math.round(progress * 100) / 100;

    const killTimeline = (timeline) => {
      setTimeout(() => {
        const targets = timeline.getChildren();
        timeline.kill();
        for (let i = 0; i < targets.length; i++) {
          if (targets[i].targets && targets[i].targets().length) {
            gsap.set(targets[i].targets(), { clearProps: 'all' });
          }
        }
      }, 1000);
    };

    // First, clear any existing inline styles that might be preventing animation
    gsap.set(
      jQuery(
        '.legacy-intro__wrapper .subtitle, .legacy-intro__wrapper .title, .legacy-intro__wrapper .paragraph, .legacy-intro__wrapper .legacy-story-link'
      ),
      {
        clearProps: 'all',
      }
    );

    let introTL = new TimelineMax({ paused: true });
    introTL
      .fromTo(
        jQuery('.legacy-intro__wrapper .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        0
      )
      .fromTo(
        jQuery('.legacy-intro__wrapper .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.legacy-intro__wrapper .paragraph'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.legacy-intro__wrapper .legacy-story-link'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      );

    Legacy.legacyIntro = new ScrollMagic.Scene({
      triggerElement: '.legacy-intro__wrapper',
      duration: '50%',
      triggerHook: 0.8,
      offset: 0,
    })
      .on('enter', function (event) {
        introTL.play();
      })
      .on('leave', function (event) {
        // Empty handler for leave event
      });

    // Clear existing inline styles for slider elements too
    gsap.set(
      jQuery(
        '.legacy-slider__wrapper .legacy-slider-content, .legacy-slider__wrapper .legacy-slider__position, .legacy-slider__wrapper .legacy-slider-controller'
      ),
      {
        clearProps: 'all',
      }
    );

    let legacySliderTL = new TimelineMax({ paused: true });
    legacySliderTL
      .fromTo(
        jQuery('.legacy-slider__wrapper .legacy-slider-content'),
        0.8,
        { x: -18, ease: Power2.easeIn },
        { x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.legacy-slider__wrapper .legacy-slider__position'),
        0.8,
        { x: 18, ease: Power2.easeIn },
        { x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.legacy-slider__wrapper .legacy-slider-controller'),
        0.8,
        { y: 20, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeInOut }
      );

    Legacy.legacySlider = new ScrollMagic.Scene({
      triggerElement: '.legacy-slider__wrapper',
      duration: '50%',
      triggerHook: 0.8,
      offset: 0,
    })
      .on('enter', function (event) {
        legacySliderTL.play();
      })
      .on('leave', function (event) {
        // Empty handler for leave event
      });

    // Clear mondavi family styles
    gsap.set(
      jQuery(
        '.mondavi-family__container .content .subtitle, .mondavi-family__container .content .title, .mondavi-family__container .left-image'
      ),
      {
        clearProps: 'all',
      }
    );

    let mondaviFamTLOne = new TimelineMax({ paused: true });
    mondaviFamTLOne
      .fromTo(
        jQuery('.mondavi-family__container .content .subtitle'),
        0.8,
        { autoAlpha: 0, x: -18, ease: Power2.easeIn },
        { autoAlpha: 1, x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.mondavi-family__container .content .title'),
        0.8,
        { autoAlpha: 0, x: 18, ease: Power2.easeIn },
        { autoAlpha: 1, x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.mondavi-family__container .left-image'),
        0.8,
        { y: 20, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeInOut },
        0
      );

    gsap.set(
      jQuery(
        '.mondavi-family__container .content img, .mondavi-family__container .paragraph, .mondavi-family__container .brand-link'
      ),
      {
        clearProps: 'all',
      }
    );

    let mondaviFamTLTwo = new TimelineMax({ paused: true });
    mondaviFamTLTwo
      .fromTo(
        jQuery('.mondavi-family__container .content img'),
        0.8,
        { autoAlpha: 0, x: -18, ease: Power2.easeIn },
        { autoAlpha: 1, x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.mondavi-family__container .paragraph'),
        0.8,
        { autoAlpha: 0, x: 18, ease: Power2.easeIn },
        { autoAlpha: 1, x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.mondavi-family__container .brand-link'),
        0.8,
        { y: 20, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeInOut },
        0
      );

    gsap.set(jQuery('.mondavi-family__container .center-image'), {
      clearProps: 'all',
    });

    let mondaviFamTLThree = new TimelineMax({ paused: true });
    mondaviFamTLThree.fromTo(
      jQuery('.mondavi-family__container .center-image'),
      0.8,
      { y: 20, autoAlpha: 0, ease: Power2.easeIn },
      { y: 0, autoAlpha: 1, ease: Power2.easeInOut },
      0
    );

    let mondaviSectionHeight = jQuery('.mondavi-family__container').outerHeight(true);

    Legacy.legacyMondavi = new ScrollMagic.Scene({
      triggerElement: '.mondavi-family__container',
      duration: mondaviSectionHeight,
      triggerHook: 0.8,
      offset: 0,
    }).on('progress', function (event) {
      // staggered like this in case page load is between progress
      if (event.progress < 0.33) {
        mondaviFamTLOne.play();
      } else if (event.progress > 0.33 && event.progress < 0.84) {
        if (mondaviFamTLOne.progress() !== 1) {
          mondaviFamTLOne.play();
        }
        mondaviFamTLTwo.play();
      } else if (event.progress > 0.84 && event.progress < 1) {
        if (mondaviFamTLOne.progress() !== 1) {
          mondaviFamTLOne.play();
          mondaviFamTLTwo.play();
        }
        mondaviFamTLThree.play();
      }
    });

    // Clear generations content
    gsap.set(
      jQuery(
        '.generations__wrapper .intro .subtitle, .generations__wrapper .intro .title, .generations__wrapper .intro .paragraph'
      ),
      {
        clearProps: 'all',
      }
    );

    let genTLOne = new TimelineMax({ paused: true });
    genTLOne
      .fromTo(
        jQuery('.generations__wrapper .intro .subtitle'),
        0.8,
        { autoAlpha: 0, x: -18, ease: Power2.easeIn },
        { autoAlpha: 1, x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.generations__wrapper .intro .title'),
        0.8,
        { autoAlpha: 0, x: 18, ease: Power2.easeIn },
        { autoAlpha: 1, x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.generations__wrapper .intro .paragraph'),
        0.8,
        { y: 20, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeInOut },
        0
      );

    gsap.set(jQuery('.generation.first-generation, .generation.second-generation'), {
      clearProps: 'all',
    });

    let genTLTwo = new TimelineMax({ paused: true });
    genTLTwo
      .fromTo(
        jQuery('.generation.first-generation'),
        0.8,
        { y: 20, autoAlpha: 0, ease: Power2.easeIn },
        {
          y: 0,
          autoAlpha: 1,
          ease: Power2.easeInOut,
          onComplete: function () {
            gsap.set(jQuery('.generation.first-generation'), { clearProps: 'all' });
          },
        },
        '+=0'
      )
      .fromTo(
        jQuery('.generation.second-generation'),
        0.8,
        { y: 20, autoAlpha: 0, ease: Power2.easeIn },
        {
          y: 0,
          autoAlpha: 1,
          ease: Power2.easeInOut,
          onComplete: function () {
            gsap.set(jQuery('.generation.second-generation'), { clearProps: 'all' });
          },
        },
        '+=0'
      );

    gsap.set(jQuery('.generation.third-generation, .generation.forth-generation'), {
      clearProps: 'all',
    });

    let genTLThree = new TimelineMax({ paused: true });
    genTLThree
      .fromTo(
        jQuery('.generation.third-generation'),
        0.8,
        { y: 20, autoAlpha: 0, ease: Power2.easeIn },
        {
          y: 0,
          autoAlpha: 1,
          ease: Power2.easeInOut,
          onComplete: function () {
            gsap.set(jQuery('.generation.third-generation'), { clearProps: 'all' });
          },
        },
        '+=0'
      )
      .fromTo(
        jQuery('.generation.forth-generation'),
        0.8,
        { y: 20, autoAlpha: 0, ease: Power2.easeIn },
        {
          y: 0,
          autoAlpha: 1,
          ease: Power2.easeInOut,
          onComplete: function () {
            gsap.set(jQuery('.generation.forth-generation'), { clearProps: 'all' });
          },
        },
        '+=0'
      );

    let genSectionHeight = jQuery('.generations__wrapper').outerHeight(true);

    Legacy.legacyGen = new ScrollMagic.Scene({
      triggerElement: '.generations__wrapper',
      duration: genSectionHeight,
      triggerHook: 0.8,
      offset: 0,
    }).on('progress', function (event) {
      // staggered like this in case page load is between progress
      if (event.progress < 0.35) {
        genTLOne.play();
      } else if (event.progress > 0.35 && event.progress < 0.58) {
        if (genTLOne.progress() !== 1) {
          genTLOne.play();
        }
        genTLTwo.play();
      } else if (event.progress > 0.6 && event.progress < 1) {
        if (genTLOne.progress() !== 1) {
          genTLOne.play();
          genTLTwo.play();
        }
        genTLThree.play();
      }
    });

    // Add all scenes to the controller
    this.legacyController.addScene([
      Legacy.legacyIntro,
      Legacy.legacySlider,
      Legacy.legacyMondavi,
      Legacy.legacyGen,
    ]);

    // Force a scroll event to trigger any scenes that might be in view
    window.dispatchEvent(new Event('scroll'));
  },

  LegacyTreeMobileSlider: function () {
    let $genSlider = jQuery('.gen__controllers');
    let $genPortrait = jQuery('.gen__portraits');

    $genSlider.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      prevArrow: jQuery('.gen__arrows .prev svg'),
      nextArrow: jQuery('.gen__arrows .next svg'),
      asNavFor: '.gen__portraits',
    });

    $genPortrait.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      dots: false,
      fade: true,
      arrows: false,
      asNavFor: '.gen__controllers',
    });
  },

  destroyController: function () {
    if (this.legacyController) {
      // Remove all scenes before destroying controller
      this.legacyController.destroy(true);
      this.legacyController = null;
    }
  },

  init: function () {
    // Initialize a new controller if needed
    if (!this.legacyController) {
      this.legacyController = new ScrollMagic.Controller();
    }

    // Make sure the LegacySlider is called after a small delay to ensure DOM is ready
    setTimeout(() => {
      this.LegacySlider();
    }, 100);

    // NOTE: Lazy loading has been disabled. All images now use direct src attributes.

    this.LegacyMobile();

    // Delay tooltip initialization to ensure DOM is ready
    setTimeout(() => {
      this.TreeTooltips();
    }, 150);

    this.LegacyTreeMobileSlider();
  },
};

// Create hooks for Barba.js modern API
const legacyHooks = {
  beforeEnter() {
    // Prepare for transition
    // Reset any elements that might have leftover styles
    gsap.set(
      '.legacy-intro__wrapper .subtitle, .legacy-intro__wrapper .title, .legacy-intro__wrapper .paragraph, .legacy-intro__wrapper .legacy-story-link',
      {
        clearProps: 'all',
      }
    );
  },
  enter() {
    // The new Container is ready and attached to the DOM.
    Legacy.init();
  },
  afterEnter() {
    // The Transition has just finished.
    if (!App.isMobile()) {
      // Ensure controller is created before setting up animations
      if (!Legacy.legacyController) {
        Legacy.legacyController = new ScrollMagic.Controller();
      }
      Legacy.legacyScrollAnim();

      // Reinitialize sliders to ensure they work properly after transitions
      setTimeout(() => {
        Legacy.LegacySlider();
      }, 200);
    }

    // Make sure tooltips are initialized after DOM is completely updated
    // This ensures the event handlers are attached to elements that exist
    setTimeout(() => {
      console.log('Re-initializing tooltips after page transition');
      Legacy.TreeTooltips();
    }, 300);
  },
  leave() {
    // A new Transition toward a new page has just started.
    Legacy.destroyController();
  },
};

// Make hooks available for Barba.js
Legacy.barbaHooks = legacyHooks;

export default Legacy;
